export enum DesktopType {
  Windows = 'windows',
  Mac = 'mac',
  None = 'none',
}
